var _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurrenderedPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bae0bd",
    d: "M11.2 21.5L13.5 21.5 13.5 13.5 16.5 13.5 16.5 21.5 18.8 21.5 15 25.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e9c76",
    d: "M16,14v7v1h1h0.6L15,24.6L12.4,22H13h1v-1v-7H16 M17,13h-4v8h-3l5,5l5-5h-3V13L17,13z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeea3",
    d: "M15 1.5A6.5 6.5 0 1 0 15 14.5A6.5 6.5 0 1 0 15 1.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M15,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S11.7,2,15,2 M15,1c-3.9,0-7,3.1-7,7s3.1,7,7,7 s7-3.1,7-7S18.9,1,15,1L15,1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5ce85",
    d: "M15 3A5 5 0 1 0 15 13A5 5 0 1 0 15 3Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M24.5,29h-19C4.1,29,3,27.9,3,26.5V13H1v-1h3v14.5C4,27.3,4.7,28,5.5,28h19c0.8,0,1.5-0.7,1.5-1.5V12 h3v1h-2v13.5C27,27.9,25.9,29,24.5,29z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#967a44",
    d: "M13.5,10.5V9.6c0.4,0.2,0.7,0.4,1.1,0.4c0.4,0,0.7-0.1,0.9-0.3s0.3-0.4,0.3-0.8 c0-0.3-0.1-0.6-0.4-0.7c-0.2-0.2-0.6-0.3-1-0.3c-0.1,0-0.5,0-0.9,0l0.2-2.9h2.7v0.8h-2l-0.1,1.4c0.2,0,0.3,0,0.5,0 c0.6,0,1,0.2,1.4,0.5s0.5,0.7,0.5,1.2c0,0.6-0.2,1-0.6,1.3s-0.9,0.5-1.5,0.5C14.2,10.7,13.8,10.7,13.5,10.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurrenderedPic);
export default __webpack_public_path__ + "static/media/surrendered_pic.86cfc7934eb0820bc5b1563f2a5ed0c4.svg";
export { ForwardRef as ReactComponent };